import { useMemo } from 'react';
import { useDispatch } from '../../../react-redux';
import { addTranslateData, removeTranslateData, removeTranslateDataByPage } from '../../../reducers/translate';

const useTranslate = () => {
  const dispatch = useDispatch();

  const extraAction = useMemo(() => {
    const actionKeyName = ['addTranslateData', 'removeTranslateData', 'removeTranslateDataByPage'];
    return [addTranslateData, removeTranslateData, removeTranslateDataByPage].reduce((prev, now, index) => {
      return {
        ...prev,
        [actionKeyName[index]]: param => dispatch(now(param))
      };
    }, {});
  }, [dispatch]);

  return {
    ...extraAction
  };
};

export default useTranslate;
